// signature.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonInterceptor } from './common.interceptor';

@Injectable({
  providedIn: 'root',
})
export class SignatureInterceptor extends CommonInterceptor {
  override intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.startsWith('/api')) {
      // 生成签名参数（你可以自定义生成规则）
      const jwt = sessionStorage.getItem('_token');
      if (jwt) {
        // 加入新的头信息;
        request = request.clone({
          setHeaders: {
            Authorization: jwt,
          },
        });
      }
    }
    return super.intercept(request, next);
  }
}
